import React from "react";
import { LegalPage, LegalSection, LegalList } from "@/components/LegalPage";

const Cookies = () => {
  return (
    <LegalPage
      overline="Legal"
      title="Cookie Notice"
      effectiveDate="March 2026"
      testId="cookies-page"
    >
      <p>
        This Cookie Notice explains how{" "}
        <strong className="text-navy">Taonga OÜ</strong> approaches cookies and
        similar technologies on this website. It should be read together with
        our Privacy Policy.
      </p>

      <LegalSection number={1} title="What Cookies Are">
        <p>
          Cookies are small text files that a website may store on your device
          when you visit it. They are commonly used to make websites work
          properly, to remember preferences, and — on many sites — to perform
          analytics or advertising. Similar technologies include local storage
          and pixel tags.
        </p>
      </LegalSection>

      <LegalSection number={2} title="Our Approach" testId="cookies-approach">
        <p>
          This website is designed to be minimal and privacy-respecting.
          Taonga OÜ does <strong className="text-navy">not</strong> use:
        </p>
        <LegalList
          items={[
            "Analytics cookies",
            "Advertising or marketing cookies",
            "Cross-site tracking technologies",
            "Third-party social media tracking pixels",
          ]}
        />
        <p>
          We may use a small number of <strong>strictly necessary</strong>{" "}
          technologies — for example to support the basic operation of the
          site or to remember your acceptance of this notice. Strictly
          necessary cookies do not require prior consent under Estonian and EU
          ePrivacy rules.
        </p>
      </LegalSection>

      <LegalSection number={3} title="Third-Party Services">
        <p>
          The website does not embed third-party advertising or analytics
          services. If, in the future, we introduce a third-party service that
          uses cookies (for example, a contact form provider or a regulated
          analytics tool), this notice will be updated and, where required by
          law, your prior consent will be requested.
        </p>
      </LegalSection>

      <LegalSection number={4} title="Managing Cookies">
        <p>
          You can configure most browsers to refuse cookies, alert you when
          cookies are being set, or delete cookies that have already been
          stored. Helpful instructions are available in the support
          documentation of your browser:
        </p>
        <LegalList
          items={[
            "Google Chrome — Settings → Privacy and security → Cookies and other site data",
            "Apple Safari — Preferences → Privacy",
            "Mozilla Firefox — Settings → Privacy & Security",
            "Microsoft Edge — Settings → Cookies and site permissions",
          ]}
        />
        <p>
          Please note that disabling strictly necessary cookies may affect the
          functioning of the website.
        </p>
      </LegalSection>

      <LegalSection number={5} title="Your Rights">
        <p>
          For information about how we process any personal data and your
          rights under the GDPR, please refer to our Privacy Policy.
        </p>
      </LegalSection>

      <LegalSection number={6} title="Updates">
        <p>
          We may update this Cookie Notice from time to time. The latest
          version will always be available on this page with the updated
          effective date.
        </p>
      </LegalSection>

      <LegalSection number={7} title="Contact">
        <p>
          For any question about this Cookie Notice, please write to{" "}
          <a
            href="mailto:info@taonga.eu"
            className="text-navy hover:text-warm transition-colors"
          >
            info@taonga.eu
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default Cookies;
